var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.056 268.331C467.056 268.331 372.691 371.017 318.377 379.628C264.063 388.24 252.329 387.471 252.329 387.471",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.721 271.844C466.721 271.844 372.354 169.158 318.04 160.545C263.727 151.933 251.994 152.702 251.994 152.702",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.545 283.148C53.545 283.148 143.556 373.065 195.365 380.606C247.172 388.146 258.365 387.474 258.365 387.474",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9441 282.544L246.939 282.544",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.498 112.511L249.498 285.903",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.93 281.27L140.521 216.817L122.68 217.082L122.557 203.419L154.747 190.412L154.247 162.688L174.443 162.688L174.069 177.476L210.791 151.553L252.587 185.963",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.892 152.69C255.32 152.69 252.797 152.914 250.267 153.076L250.267 284.689L141.482 284.689C148.67 342.638 197.998 387.489 257.892 387.489C322.729 387.489 375.267 334.952 375.267 270.114C375.267 205.277 322.729 152.69 257.892 152.69Z",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 13.058
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.564 200.735C214.267 200.735 183.258 231.795 183.258 270.09C183.258 308.385 214.267 339.443 252.564 339.443C290.859 339.443 321.915 308.385 321.915 270.09C321.915 261.351 320.138 253.08 317.188 245.379C312.037 253.228 303.194 258.409 293.104 258.409C277.183 258.409 264.243 245.518 264.243 229.597C264.243 219.507 269.472 210.616 277.321 205.465C269.62 202.516 261.302 200.735 252.564 200.735Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "nonzero",
    id: "ClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.564 200.735C214.267 200.735 183.258 231.795 183.258 270.09C183.258 308.385 214.267 339.443 252.564 339.443C290.859 339.443 321.915 308.385 321.915 270.09C321.915 261.351 320.138 253.08 317.188 245.379C312.037 253.228 303.194 258.409 293.104 258.409C277.183 258.409 264.243 245.518 264.243 229.597C264.243 219.507 269.472 210.616 277.321 205.465C269.62 202.516 261.302 200.735 252.564 200.735Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ClipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L178.78 444.049L180.994 120.01L326.394 121.077Z",
    fill: "#770088",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L203.013 444.226L205.228 120.188L326.394 121.077Z",
    fill: "#004cff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L227.246 444.406L229.461 120.365L326.394 121.077Z",
    fill: "#028121",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L251.48 444.583L253.694 120.543L326.394 121.077Z",
    fill: "#ffee00",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L275.713 444.761L277.928 120.722L326.394 121.077Z",
    fill: "#ff8d00",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 121.077L324.18 445.116L299.946 444.938L302.161 120.9L326.394 121.077Z",
    fill: "#e50000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniWhite);
export default __webpack_public_path__ + "static/media/miniWhite.702160afad0e33f3f109e27774e19925.svg";
export { ForwardRef as ReactComponent };